import { openBlock as e, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ c("path", { d: "M.845 8c0-2.84 2.31-5.15 5.15-5.15.18 0 .35.01.51.04h.13v1.84l-.17-.02c-.16-.02-.32-.03-.47-.03-1.83 0-3.31 1.49-3.31 3.32 0 1.83 1.49 3.32 3.32 3.32.15 0 .31-.01.47-.03l.17-.03v1.86h-.14c-.17.03-.34.03-.51.03-2.84 0-5.15-2.31-5.15-5.15Zm14.13-3.29c-.16-.02-.32-.03-.47-.03v.01a3.33 3.33 0 0 0-3.2 2.44h2.83v1.78h-2.82c.44 1.56 2.02 2.61 3.67 2.38l.17-.03v1.86h-.14c-.17.03-.34.03-.51.03-2.84 0-5.15-2.31-5.15-5.15 0-2.84 2.31-5.15 5.15-5.15.18 0 .34.01.51.04h.13v1.84l-.17-.02Z" }, null, -1), h = [
  n
];
function l(r, s) {
  return e(), t("svg", o, [...h]);
}
const d = { render: l };
export {
  d as default,
  l as render
};
